/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import FormGroup from '@material-ui/core/FormGroup';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';

import styles from './ElectroRadioGroup.module.scss';

/**
 * ElectroRadioGroup
 *
 * @prop   {Object}   field
 * @prop   {String}   heading
 * @prop   {String}   secondaryKey
 * @prop   {Boolean}  inline
 * @prop   {Boolean}  disabled
 * @prop   {Boolean}  isBoolean
 * @prop   {String}   inputLabel
 * @prop   {Function} customComp
 * @return {React.Node}
 */

type TypeProps = {
  field: Object,
  heading?: string,
  secondaryKey?: string,
  isBoolean?: boolean,
  disabled?: boolean,
  inline?: boolean,
  customComp?: Function,
  onChange?: Function,
};

const ElectroRadioGroup: React.StatelessFunctionalComponent<*> = ({
  field,
  secondaryKey,
  inline,
  disabled,
  customComp,
  isBoolean,
  onChange,
}: TypeProps) => {
  const isInline: ?string = inline ? styles.inline : null;
  const isRequired: boolean = Boolean(field.rules && field.rules.indexOf('required') > -1);
  const options: Array<Object> =
    field.extra && field.extra.options ? field.extra.options : field.options;

  return (
    <div className={`${styles['radio-group']} ${isInline ? isInline : ''}`}>
      <FormControl disabled={disabled}>
        <InputLabel required={isRequired} shrink={true}>
          {field.label}
        </InputLabel>
        <FormGroup className={styles['radio-form-group']}>
          {options.map((option: Object) => (
            <FormGroup key={option.id}>
              <FormControlLabel
                value={option.value.toString()}
                label={option.label}
                control={<Radio checked={option.value == field.value} />}
                onChange={(evt: SyntheticInputEvent) => {
                  const value = isBoolean ? evt.target.value === 'true' : evt.target.value;
                  field.set(value);

                  if (onChange) {
                    onChange(value);
                  }
                }}
              />
              {secondaryKey && option[secondaryKey] && <p>{option[secondaryKey]}</p>}
              {customComp && customComp(option)}
            </FormGroup>
          ))}
        </FormGroup>
        {field.showError && field.error && (
          <FormHelperText error={true}>{field.error}</FormHelperText>
        )}
      </FormControl>
    </div>
  );
};

export default observer(ElectroRadioGroup);
